<template>
	<div class="bg-orange-50 px-4 sm:px-5 py-2 rounded-xl shadow-lg mb-[20px] border border-orange-300 text-orange-600">
		<div class="grid grid-cols-1 sm:grid-cols-2 gap-2">
			<div class="col-span-1 flex justify-start items-center py-1">
                <LucideIcon name="Blocks" :size=20 :stroke-width="2" color="#ea580c"/>
				<div>
					<p class="text-base font-medium pl-2">You own this offer</p>
				</div>
            </div>
			<div class="col-span-1 w-full grid grid-cols-1 xs:grid-cols-2 gap-y-1 gap-x-2 pb-1 sm:pb-0 sm:flex  sm:justify-end sm:items-center">
				<slot></slot>
			</div>
		</div>
	</div>
</template>

<script>
import LucideIcon from "@/components/LucideIcon.vue";

export default {
	name:"frozen-header",
	components:{
		LucideIcon
	},
	props:{
		logo:{
			type:String
		},	
		title:{
			type:String
		},
		subText:{
			type:String
		},
		icon:{
			type:String
		}
	},
	data(){
		return{

		}
	},
	mounted(){

	}

}
</script>

<style>

</style>